import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

const AgeRange = ({ minAge = 0, maxAge = '99+' }) => (
  <li>
    {trans('property_show.instant_booking_modal.age')} {minAge}-{maxAge}
  </li>
);

AgeRange.propTypes = {
  minAge: PropTypes.number,
  maxAge: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default AgeRange;
